<template>
  <div class="content background1">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title">{{$t('label_375')}}</p>
            <div class="chooseBox spaceBetween">
              <div class="chooseBox">
                <div class="selectBox" style="width: 100%">
                  <div style="display: flex;align-items: center;">
                    <div>
                      <div class="selectChoose" style="width: 478px;margin-left: 10px;">
                        <div class="selectText">
                          <p>{{$t('label_377')}}</p>
                        </div>
                        <div class="select" style="width:610px">
                          <el-date-picker v-model="Readytime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                            :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
                          </el-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="selectChoose">
                      <div class="selectText" style="width: 180px">
                        <p >{{$t('label_381')}}</p>
                      </div>
                      <el-select v-model="value" :placeholder="$t('input_65')" @change="selechange" clearable>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;" class="spaceBetween">
                    <div>
                      <div class="selectChoose" style="width: 310px; padding-left: 15px">
                        <div class="selectText">
                          <p>{{$t('label_383')}}</p>
                        </div>
                        <el-select v-model="Warehousevalue" :placeholder="$t('input_65')" @change="Warehouseselect" clearable>
                          <el-option v-for="item in Warehouselist" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div>
                      <div class="selectChoose" style="padding-left: 20px; width: 440px">
                        <div class="selectText">
                          <p>{{$t('label_664')}}</p>
                        </div>
                        <div class="select">
                          <el-input v-model="Accessoryname" clearable></el-input>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="selectChoose">
                        <div class="selectText">
                          <p>{{$t('label_129')}}</p>
                        </div>
                        <div class="select">
                          <el-input v-model="Accessorymodel" clearable></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="buttonBox buttonBoxRight" style="margin-right: 10px;">
                    <div>
                      <div class="chooseButton sendButton" @click="search" ><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="spotMes2Box" :style="{'height':'calc(100% - 150px)'}">
<!--/*              <div class="buttonBox" style="margin-bottom: 10px;">*/-->
<!--                <div>-->
<!--                  <div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('7')>=0">-->
<!--                    <i class="el-icon-download"></i>{{$t('btn_10')}}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
              <div class="tableMin" style="height: calc(100% - 100px);">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row
                  @current-change="handleCurrentChangeTree" border style="width: 100%;" height="100%"
                  :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex"
                    width="50">
                  </el-table-column>
                  <el-table-column :label="$t('label_381')" align="left">
                    <template slot-scope="scope">
                      <span v-if="scope.row.type==1">{{$t('label_399')}}</span>
                      <span v-if="scope.row.type==21">{{$t('label_402')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="code" :label="$t('label_124')" align="left">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_664')" align="center">
                  </el-table-column>
                  <el-table-column prop="model" :label="$t('label_129')" align="left">
                  </el-table-column>
                  <el-table-column prop="maker" :label="$t('label_672')" align="left">
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.maker" :hoverMes="scope.row.maker" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="num" :label="$t('label_668')" align="left">
                  </el-table-column>
                  <el-table-column prop="recordTime" :label="$t('label_377')" align="left">
                  </el-table-column>
                  <el-table-column prop="operationUser" :label="$t('label_502')" align="left">
                  </el-table-column>
                  <el-table-column prop="warehouseName" :label="$t('label_327')" align="left">
                  </el-table-column>
                  <el-table-column prop="warehouseName" :label="$t('label_386')" align="left">
                    <template slot-scope="scope">
                      {{(scope.row.taskType!==''&&scope.row.taskType!==null)?scope.row.taskType===0 ? $t('label_390') + ':' : $t('btn_43') + ':' :''}} {{(scope.row.taskType!==''&&scope.row.taskType!==null)?scope.row.taskType===0?scope.row.maintainEqCode:scope.row.repairEqCode:''}}<br>{{(scope.row.taskType!==''&&scope.row.taskType!==null)?scope.row.taskType===0?scope.row.maintainEqName:scope.row.repairEqName:''}}

                    </template>
                  </el-table-column>
                </el-table>
                <div style="position: absolute;bottom: 30px;left: 30%">
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
                    :currentspage="1" @parentMethod="searchPage"></Page>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"-->
    <!--		 ref="exportBox"></exportMes>-->
  </div>

</template>

<script>
  import "@/assets/css/map/map.css"
  import "@/assets/css/common/spot.css"
  import Page from "@/components/common/page";
  import TimePage from "@/assets/js/timePage/timePage.js";
  import utils from '@/utils/utils'
  import calendar from "@/components/list/calendar/calendar";
  import file from "@/assets/js/file/file.js";
  import exportMes from "@/components/list/export/export";
  import popMesBox from "@/components/list/popover/pop";

  export default {
    name: 'outRecord',
    components: {
      Page,
      calendar,
      exportMes,
      popMesBox,
    },
    data() {
      return {
        Accessoryname: '', // 配件名称
        Accessorymodel: '', // 配件型号
        Warehouse: '', // 所属仓库
        code: '',
        pageNum: 1,
        select: 0,
        pageSize: 10,
        pageCount: 0,
        Readytime: '',
        height: 620,
        MenuRoleList: [],
        exportTitle: this.$t('label_396'),
        options: [{
          value: '0',
          label: this.$t('label_272')
        }, {
          value: '1',
          label: this.$t('label_399')
        }, {
          value: '21',
          label: this.$t('label_402')
        }],
        value: '0',
        tableDataTreeInfo: {},
        factoryDialogTitle: this.$t('btn_14'),
        getTreeMes: '1',
        dialogFactory: false,
        searchDataList: {
          list: [],
          name: '',
          language: 'zh',
        },
        tableDataTreeTime: [],
        tableDataTreeTimeExport: [],
        tableDataTree: [],
        factoryTypeList: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        Warehouselist: [], // 所属仓库list
        Warehousevalue: '0',
        Warehouseselectname: '', // 所属仓库 下拉选值
        selechangename: '', // 操作类型
        linshi: [{
          name: '测试1',
          id: '0'
        }, {
          name: '测试2',
          id: '1'
        }, {
          name: '测试3',
          id: '2'
        }],
        cehsi: [{
          name: '测试4',
          id: '3'
        }, {
          name: '测试5',
          id: '4'
        }],
        alllist: [],
        dateTime: '',
        dateValue: [],
      }
    },
    methods: {
      // 操作类型下拉
      selechange(val) {
        this.selechangename = val
      },
      // 所属仓库
      Warehouseselect(val) {
        this.Warehouseselectname = val
      },
      // 点击查询按钮
      searchname(param) {
        // let param = {
        //   recordTimeBegin : this.Readytime[0],
        //   recordTimeEnd : this.Readytime[1],
        //   type: this.selechangename,
        //   warehouseId: this.Warehouseselectname,
        //   name: this.Accessoryname,
        //   model: this.Accessorymodel,
        //   pageNum: 1,
        //   pageSize: this.pageSize
        // }
        file.getinoutselect(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDataTreeTime = data.data.records
            this.pageCount = data.data.total;
            this.pageSize = data.data.size;
            this.pageNum = data.data.current;
            this.$refs['pageModel'].setCurrent(this.pageNum);
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      // 仓库下拉选
      getWarehousedowns() {
        file.getWarehousedown().then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.Warehouselist = data.data;
            this.Warehouselist.unshift({
              name: this.$t('label_272'),
              id: '0'
            })
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      //获取时间的默认值
      getDate() {
        let start = this.Fungetdate(-7) // 7天前
        let end = this.Fungetdate(0) // 当前时间
        this.dateValue.push(start, end)
        console.log('aaaa', start)
        this.Readytime = this.dateValue
      },
      //  当前时间
      Fungetdate(num) {
        var sdd = new Date();
        sdd.setDate(sdd.getDate() + num);
        var yyyy = sdd.getFullYear();
        // var MM = sdd.getMonth() + 1;//获取当前月份的日期
        let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
        var dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
        let HH = sdd.getHours() < 10 ? '0' + sdd.getHours() : sdd.getHours()
        let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
        let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
        return yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss;
      },

      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      exportClick() {
        this.$refs.exportBox.setExportExcel();
      },
      selectProp: function(index) {
        console.log(index)
        this.select = index
      },
      handler() {

      },
      searchPage(param) {
        let dataParam = {
          recordTimeBegin: this.Readytime[0],
          recordTimeEnd: this.Readytime[1],
          type: this.value,
          warehouseId: this.Warehousevalue,
          name: this.Accessoryname,
          model: this.Accessorymodel,
        }
        var newParam = Object.assign(param, dataParam);
        this.pageNum = newParam.pageNum;
        this.pageSize = newParam.pageSize;
        this.searchname(newParam);
      },
      handleCurrentChangeTree(info) {
        this.tableDataTreeInfo = info;
      },
      handleCurrentChangeTreeTime(info) {},
      search() {
        let param = {
          pageNum: 1,
          pageSize: this.pageSize
        }
        if (this.Readytime == null || this.Readytime == '' || this.Readytime == undefined) { //  判断一下 日期不能为空
          this.$message({
            message: this.$t('msg_49'),
            type: 'warning'
          });
        } else {
          this.searchPage(param);
        }
      },
    },
    exportList() {

    },
    created() {
      this.Fungetdate() // 获取当前时间
      this.getDate() //  设置默认时间
      this.getWarehousedowns() // 仓库下拉选
      this.search()
    }
  }
</script>

<style scoped>
  .el-select {
    width: 203px;
  }

  .chooseBox {
    height: 88px;
    width: 99%;
  }

  .el-table__column-filter-trigger i {
    color: #FFFFFF;
    font-size: 20px;
  }

  .selectBox .selectChoose {
    width: 390px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/part/outRecord.vue